import { DrawerContext } from "context/DrawerContext";
import useGetAssurance from "hooks/useGetAssurance";
import useGetParent from "hooks/useGetParent";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Menu2 } from "tabler-icons-react";
import Credit from "./Credit";

/**
 * Barre de navigation de l'espace parent.
 *
 * Pensée pour être posée sur le bandeau coloré de la page (fond transparent),
 * avec des zones de tap larges (44px) et un seul point d'entrée vers le menu.
 */
function AppHeader({
  title,
  subtitle,
  showBack = false,
  onBack,
  showCredit = true,
  showMenu = true,
  right,
}) {
  const navigation = useNavigate();
  const { handleOpen } = React.useContext(DrawerContext);
  const app = useGetAssurance();

  // Rafraîchit le parent depuis l'API (crédits inclus) et met le store à jour :
  // sans ça, le badge affichait les crédits persistés, donc périmés dès qu'ils
  // changent côté backend. C'est ce que faisait déjà l'ancien PageHeader.
  useGetParent();

  return (
    <div className="w-full flex items-center justify-between gap-2 px-3 h-[56px] text-white">
      <div className="flex items-center gap-2 min-w-0">
        {showBack ? (
          <button
            aria-label="Retour"
            onClick={() => (onBack ? onBack() : navigation(-1))}
            className="h-10 w-10 -ml-1 flex items-center justify-center rounded-full bg-white/15 active:bg-white/25 transition-colors"
          >
            <ChevronLeft size={22} />
          </button>
        ) : (
          <div className="h-10 w-10 rounded-full bg-white/15 flex items-center justify-center overflow-hidden">
            <img
              src={
                app === "Senassurance"
                  ? "/icons/senassurance.png"
                  : "/icons/icon1.png"
              }
              alt="Genimi"
              className="w-7 h-7 object-contain"
            />
          </div>
        )}

        <div className="min-w-0">
          <p className="font-bold text-[15px] leading-tight truncate">
            {title ?? "Genimi"}
          </p>
          {subtitle ? (
            <p className="text-[11px] leading-tight opacity-80 truncate">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        {right}
        {showCredit ? <Credit compact /> : null}
        {showMenu ? (
          <button
            aria-label="Menu"
            onClick={handleOpen}
            className="h-10 w-10 flex items-center justify-center rounded-full bg-white/15 active:bg-white/25 transition-colors"
          >
            <Menu2 size={20} />
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default AppHeader;
